export enum ModalMode {
  NORMAL = 1,
  QR_CODE = 2,
}
